export default "__VITE_ASSET__ClVTZM7Y__"